export const setPanel = (value) => ({
	type: 'SET_PANEL',
	value,
})
